import React, { Component } from 'react';

export default class Comment extends Component {

    render() {
        return (
            <div className="w-100 comment-body">
                {/* comment */}
                {/* <div className="comment d-flex">
                                <img className="user-avatar" src="/static/img/user.png" alt="avatar" />
                                <div className="m-0 w-100">
                                    <div className="detail-comment">
                                        <h4>UserName</h4>
                                        <p>afhbbbbbbbadf da hfudsfnjd njds  ehofas fds fhdfhsdh fuohadufh oshdfj sdmanfj ejhwf jndjfn dahf jsajndsj afuhw hfsfs</p>
                                    </div>
                                    <div className="comment-reply d-flex">
                                        <img className="user-avatar" src="/static/img/user.png" alt="avatar" />
                                        <div className="detail-comment">
                                            <h4>UserName</h4>
                                            <p>afhbbbbbbbadf da hfudsfnjd njds  ehofas fds fhdfhsdh fuohadufh oshdfj sdmanfj ejhwf jndjfn dahf jsajndsj afuhw hfsfs</p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                <br />

                {/* form for send comment */}
                <form className="row m-0 enter-comment">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mr-0 title-comment">
                        <input className="w-100" type="text" placeholder="عنوان نظر خود را بنویسید" />
                    </div>
                    <div className="col-12 mr-0 pl-0 description-comment">
                        <textarea className="w-100" placeholder="متن نظر خود را بنویسید"></textarea>
                    </div>
                    <button type="submit" className="send-btn"> ارسال نظر </button>
                </form>
            </div>
        )
    }
}